import React, { useEffect } from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import ContactSettings from "../../components/Contacts/ContactSettings";
import ContactDetails from "../../components/Contacts/ContactDetails";
import { useSelector, useDispatch } from "react-redux";
import { fetchUserPermissions } from "../../redux/Slice/User/userDetailsSlice";
import AuthView from "../../utils/AuthView";

function Contacts() {
  const dispatch = useDispatch();
  const theme = useTheme();
  const ContactPermissions = useSelector(
    (state) => state.userDetails.userPermissions?.permissions?.Contact || {}
  );

  // Breakpoint detection
  const isXl = useMediaQuery(theme.breakpoints.up("xl")); // 1536px+
  const isXs = useMediaQuery(theme.breakpoints.only("xs")); // 0-599px

  useEffect(() => {
    dispatch(fetchUserPermissions());
  }, [dispatch]);

  // Check if user has permission to view contacts
  if (ContactPermissions.View === false) {
    return <AuthView />;
  }

  const mainRowContent = (
    <>
      {/* First Column - hidden xs; 10% sm-md-lg, 20% xl */}
      {!isXs && (
        <Box
          sx={{
            width: isXl ? "20%" : "10%",
            minWidth: { sm: "100px" },
            minHeight: 0,
          }}
        >
          <ContactSettings />
        </Box>
      )}

      {/* Second Column - 100% xs, 90% sm-md-lg, 80% xl */}
      <Box
        sx={{
          width: isXl ? "80%" : isXs ? "100%" : "90%",
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          paddingLeft: isXs ? "8px" : 0,
          paddingRight: isXs ? "8px" : 0,
          paddingBottom: { xs: "12px", sm: "12px", md: "20px", lg: "20px", xl: "20px" },
          boxSizing: "border-box",
          overflow: "hidden",
          height: "100%",
        }}
      >
        <ContactDetails />
      </Box>
    </>
  );

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        flex: 1,
        overflow: "hidden",
        margin: 0,
        padding: 0,
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        // Keep a small visual gap from bottom edge on all screens.
        paddingBottom: { xs: "4px", sm: "4px", md: "16px", lg: "16px", xl: "16px" },
        boxSizing: "border-box",
      }}
    >
      {/* Main Content Area */}
      <Box
        sx={{
          width: "100%",
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flex: 1,
            minHeight: 0,
            overflow: "hidden",
            width: "100%",
          }}
        >
          {mainRowContent}
        </Box>
      </Box>
    </Box>
  );
}

export default Contacts;
